module.exports = __webpack_public_path__ + "img/logo_color.c59728a3.png";